import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { formValueSelector, actions } from 'redux-form'
import {
  SmallText,
  BodyBold,
  Body,
} from 'ggx-componentlibrary/design/typography/typography.styles'
import {
  StyledCouponSection,
  CouponModelTrigger,
  RightIcon,
  CouponIcon,
  CouponCheckIcon,
  StyledBadge,
} from 'ggx-src/van-booking/order/sidebar/order-form/summary/coupon-section.component.styles.js'
import { useSelector, useDispatch } from 'react-redux'
import { getOrderQuotation } from 'ggx-src/van-booking/duck/selectors'
import { VoucherModal } from 'ggx-src/billing/voucher/voucher-modal.component'
import {
  getActiveCoupons,
  getAvailableCouponNum,
} from 'ggx-global/duck/selectors'
import { fetchCoupon } from 'ggx-global/duck/actions'
import { DELIVERY_FORM_NAME } from 'ggx-src/delivery/order/order-form/order-form.component'

const CouponSection = ({ orderPrice, code }) => {
  const [t] = useTranslation()
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchCoupon({ orderPrice, serviceType: 'delivery' }))
  }, [])
  const [showVoucherModal, setShowVoucherModal] = useState(false)
  const selectedCouponTitle = useSelector(
    state => getActiveCoupons(state).find(coupon => coupon.code === code)?.title
  )
  const couponNum = useSelector(state => getAvailableCouponNum(state))
  return (
    <>
      <StyledCouponSection
        $isActive={couponNum > 0}
        style={{ marginTop: '20px', paddingTop: '20px', paddingBottom: '0px' }}
      >
        {!selectedCouponTitle ? <CouponIcon /> : <CouponCheckIcon />}
        <div style={{ marginRight: 'auto', overflow: 'hidden' }}>
          {!selectedCouponTitle ? (
            <CouponModelTrigger onClick={() => setShowVoucherModal(true)}>
              <BodyBold noMargin style={{ fontWeight: 600 }}>
                {t('coupon')}
              </BodyBold>
              <RightIcon />
            </CouponModelTrigger>
          ) : (
            <SmallText noMargin>{t('coupon_applied')}</SmallText>
          )}
          {!selectedCouponTitle ? (
            <SmallText key="small" noMargin>
              {t('apply_to_get_discount')}
            </SmallText>
          ) : (
            <Body
              key="body"
              typographyStyles="mt-xxs mb-xxs"
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {selectedCouponTitle}
            </Body>
          )}
        </div>
        {!selectedCouponTitle ? (
          <StyledBadge>
            {t('n_coupons_usable', { number: couponNum })}
          </StyledBadge>
        ) : (
          <Body
            noMargin
            typographyStyles="c-blue_medium"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              dispatch(
                actions.change(DELIVERY_FORM_NAME, 'user_voucher_ids', [])
              )
            }
          >
            {t('common__remove_waypoint')}
          </Body>
        )}
      </StyledCouponSection>
      {showVoucherModal && (
        <VoucherModal
          orderPrice={orderPrice}
          serviceType="delivery"
          onSelectCoupon={coupon => {
            dispatch(
              actions.change(DELIVERY_FORM_NAME, 'user_voucher_ids', [
                coupon.available[0],
              ])
            )
          }}
          onModalClose={() => setShowVoucherModal(false)}
        />
      )}
    </>
  )
}

export { CouponSection }
